import React from "react";
import SEO from "../../shared/components/atoms/seo/seo";
import Layout from "../../shared/components/organisms/layout/layout";
import { siteUrl } from '../../shared/utils/siteUrl';
import { unicodeUtil } from '../../shared/utils/unicodeUtil';
import ProductInternalContent from '../organisms/product-internal-content/product-internal-content';

const ProductInternalTemplate = props => {

    let productData = props.pageContext.params;
    let seoImg;
    let schema;

    if (productData) {
        try {
            seoImg = props.pageContext.params.metaImagen && props.pageContext.params.metaImagen.file.url;
        } catch (e) {
            console.error('error al obtener la imagen', e);
        }

        let ratingValue = productData.ratingValue !== null ? productData.ratingValue : 5;
        let reviewCount = productData.reviewCount !== null ? productData.reviewCount : 1;

        schema = {
            "@context": "https://schema.org/",
            "@type": "Product",
            "url": siteUrl + '/productos/' + props.pageContext.params.categoria[0].idCategoria + props.pageContext.slug,
            "name": unicodeUtil(productData.titulo),
            "description": unicodeUtil(productData.metaDescripcion !== undefined ? productData.metaDescripcion.metaDescripcion : ''),
            "image": seoImg,
            "sku": productData.idDelProducto,
            "mpn": productData.idDelProducto,
            "brand": {
                "@type": "Brand",
                "name": "Pequeñín",
            },
            "review": {
                "@type": "Review",
                "author": {
                    "@type": "Organization",
                    "name": "Pequeñín"
                }
            },
            "aggregateRating": {
                "@type": "AggregateRating",
                "ratingValue": ratingValue.toString(),
                "reviewCount": reviewCount.toString(),
            }
        };
    }

    return (
        <Layout activeMenu={1}>
            <SEO
                title={props.pageContext.params.metaTitulo}
                description={props.pageContext.params.metaDescripcion.metaDescripcion}
                url={siteUrl + '/productos/' + props.pageContext.params.categoria[0].idCategoria + props.pageContext.slug}
                image={props.pageContext.params.metaImagen && props.pageContext.params.metaImagen.file.url}
                script={schema}
            />
            <ProductInternalContent contentInfo={props.pageContext.params} clubData={props.pageContext.clubData} alliesData={props.pageContext.alliesData} />
        </Layout>
    )
}

export default ProductInternalTemplate;